export default "__VITE_ASSET__416eff86__"